export class RemoteData {
    public isSuccess: boolean | undefined;
    public code: string | undefined;
    public error: string | undefined;
    public message: string | undefined;
}
